import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ProjectRedirectToDashboard = () => {
    const { projectID } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        navigate(`/portfolio/${projectID}/dashboard`, { replace: true });
    }, [projectID, navigate]);

    return null;
};

export default ProjectRedirectToDashboard;
